export const UPDATE = 'UPDATE_DATATABLE';

export const UPDATEWALLET = 'UPDATEWALLET_DATATABLE';

export const UPDATETABLE = 'UPDATETABLE_DATATABLE';